export default __webpack_public_path__ + "static/media/trackerLogo.4ab076d2.jpg";